import React, { PropsWithChildren } from "react"

import { styled } from "@mui/material"

import { Card, CardContent, CardHeader, Footer, HeaderLogo } from "../components"

export const PageContent = ({ children }: PropsWithChildren) => {
  return <Container className="container">
    <Card id="sfl-container">
      <CardHeader className="panel-heading">
        <HeaderLogo className="logo-header-background"/>
      </CardHeader>

      <CardContent id="sfl-body">
        {children}
      </CardContent>
    </Card>

    <Footer/>
  </Container>
}

const Container = styled("div")({
  maxWidth: "610px",
  margin: "0 auto"
})
